<template>
    <div id="Setting" class="setting">
        <div class="headImg">
            <img :src="headImg">
        </div>
        <van-cell-group>
          <van-field v-model="nickname" label="昵称" disabled/>
          <van-field v-model="username" label="姓名" disabled/>
          <van-field v-model="sex" label="性别" @click="choiceSex()" disabled/>
          <van-field v-model="telephone" label="手机号码" placeholder="请输入手机号" disabled/>
          <van-field v-model="region" label="地区" placeholder="请选择地址" @click="choiceAdd()" disabled/>
          <van-field disabled
            v-model="address"
            label="详细地址"
            type="textarea"
            rows="1"
            autosize
        />
        </van-cell-group>

        <!-- <div class="linebox">
            <van-button size="large" type="primary">确认修改</van-button>
        </div> -->
        <van-popup v-model="show" position="bottom">
          <van-area :area-list="areaList" :value="adrCode" title="选择地址" @confirm="addadr" @cancel="cancel"/>
        </van-popup>

        <van-popup v-model="show2">
          <van-radio name="男" v-model="sex">男</van-radio><br/>
          <van-radio name="女" v-model="sex">女</van-radio><br/>
          <van-radio name="保密" v-model="sex">保密</van-radio>
        </van-popup>
        <router-link to="/shake"><p><br/></p></router-link>
    </div>
</template>

<script>
    import Vue from 'vue';
    import tool from '../../kits/Tools.js';
    import vxxData from '../../kits/data.js';
    //保存数据

    export default {
        name: 'Setting',
        data() {
            return {fansId:'',nickname:"",username:"",headImg:'',sex:'保密',address:'',show: false,adrCode:'',telephone:"",region:'',regionCode:'',show2:false,
            areaList:{
              province_list: {
                110000: '北京市',
                120000: '天津市'
              },
              city_list: {
                110100: '北京市',
                110200: '县',
                120100: '天津市',
                120200: '县'
              },
              county_list: {
                110101: '东城区',
              }
            }
            }
        },
        created() {
          var current_app_Id = window.localStorage.getItem("current_app_Id");
          var fans = JSON.parse(window.localStorage.getItem(current_app_Id));
          this.fans_id = fans.fans_id;
        },
        mounted() {
          this.$toast.loading({duration:0});
            this.getDate();
        },
        methods: {
          getDate(){
              var that = this;
              var option = 'fans_id='+this.fansId;
              this.axios.post(tool.baseUrl()+'/fans/finance/balance',option).then(function(data){
                  that.$toast.clear();
                  var userms = data.data.data
                if(data.data.code == "200") {
                  that.headImg = userms.header;
                  that.nickname = userms.nick;
                  that.region = userms.region;
                  that.telephone = userms.mobile;
                  that.real_name = userms.real_name;
                  if(userms.sex == 'man'){
                    that.sex = '男'
                  }else if(userms.sex == 'woman'){
                    that.sex = '女'
                  }else{
                    that.sex = '保密'
                  }
                } else {
                }
              }).catch(function(){
                that.$toast.clear();
              })
            },
            choiceAdd () {
                //this.show = true;
            },
            addadr (adrs){
                // this.region = adrs[0].name+adrs[1].name+adrs[2].name;
                // this.regionCode = adrs[0].code+adrs[1].code+adrs[2].code;
                // this.show = false;
            },
            cancel (){
                //this.show = false;
            },
            choiceSex (){
                //this.show2 = true;
            }
        }
    }
</script>

<style scoped>
.headImg {
  overflow: hidden;
  width: 100px;
  height: 100px;
  margin: 10px auto;
  border-radius: 50%;
}

.headImg img {
  width: 100%;
}
</style>